/**
 * Photographs bundled with the app.
 *
 * The gallery reads from Firebase Storage in normal operation. When that call
 * fails or returns nothing — an outage, a rules change, a cold project — the
 * section falls back to these so visitors still see the work rather than an
 * empty shelf.
 */
const context = require.context(
  "../assets/blogphoto",
  false,
  /\.(png|jpe?g|webp)$/i
);

const localGalleryImages = context
  .keys()
  .sort()
  .map((key) => context(key));

export default localGalleryImages;
